import React from 'react';
import { formatMessage } from '../../../../Localization/formatMessage';
import Messages from '../../../../Localization/Messages';
import { BusinessArea } from '../../../../Enums/BusinessArea';
import { getBusinessAreaByChannel } from '../../../../Helpers/AgentHelper';
import ActiveAgentMenu from './Menu/ActiveAgentsMenu';
import { isAgentActive } from '../../../../Helpers/AgentHelper';
import './Styles.css';
import CreateAgentButton from './CreateAgentButton';
import { canAgentNameBeSet } from '../../Functions';
import { canShowAgentAddressInTable } from './Functions';
import { useLegalUnitName } from '../../../../Helpers/CustomHooks';
import { getFormattedAddress } from '../../../../Helpers/AddressHelper';
import { LegalUnit } from '../../../../Enums/LegalUnit';
import { CommissionModel } from '../../../../Enums/CommissionModel';

const ActiveAgents = ({ team, areBrokerFunctionsAvailable }) => {
  const activeAgents = team?.agents?.filter(isAgentActive) ?? [];
  const legalUnitName = useLegalUnitName(team);

  return (
    <div className="teamPage_activeAgents_container">
      {activeAgents?.length > 0 && (
        <>
          <div
            className={`common-table-row ${
              legalUnitName === LegalUnit.Denmark
                ? 'teamPage-activeAgents-tableRow-denmark'
                : 'teamPage-activeAgents-tableRow'
            } headerRow`}
          >
            <div>{formatMessage(Messages.common_agentCode)}</div>
            <div>{formatMessage(Messages.common_costCenter)}</div>
            <div>{formatMessage(Messages.common_externalSalesCode)}</div>
            {canAgentNameBeSet(legalUnitName) && <div>{formatMessage(Messages.common_name)}</div>}
            <div>{formatMessage(Messages.common_additionalName)}</div>
            <div>{formatMessage(Messages.common_activationDate)}</div>
            <div>{formatMessage(Messages.common_address)}</div>
            <div></div>
            <div></div>
          </div>

          {activeAgents.map((agent, index) => {
            return (
              <div
                className={`common-table-row ${
                  legalUnitName === LegalUnit.Denmark
                    ? 'teamPage-activeAgents-tableRow-denmark'
                    : 'teamPage-activeAgents-tableRow'
                } ${index % 2 === 1 ? 'common-table-evenRow' : ''}`}
                key={index}
              >
                <div>{agent.code}</div>
                <div>{agent.costCenter?.name}</div>
                <div>{agent.externalSalesCode ? agent.externalSalesCode : '—'}</div>
                {canAgentNameBeSet(legalUnitName) && <div>{agent.name}</div>}
                {getBusinessAreaByChannel(agent.channel) === BusinessArea.Commercial ? (
                  <div>{agent.additionalName}</div>
                ) : (
                  <div>{formatMessage(Messages.activeAgents_notApplicable)}</div>
                )}
                <div>{agent.validFrom}</div>
                <div>
                  {canShowAgentAddressInTable(legalUnitName, agent)
                    ? getFormattedAddress(agent.address)
                    : agent.addressIsInherited && (
                        <img
                          alt="Address Inherited Icon"
                          title="Address Inherited"
                          src="/assets/address-inherited.svg"
                        ></img>
                      )}
                </div>
                <div>
                  {agent.isDefaultAgentCode && (
                    <img alt="Default Agent Icon" title="Default Agent" src="/assets/agent-default.svg"></img>
                  )}
                  {agent.commissionModel === CommissionModel.AssurandorIIF && (
                    <img
                      alt="AIF Commission Enabled Icon"
                      title="Commission Model Equal to AIF"
                      src="/assets/aif-commission-enabled.svg"
                    ></img>
                  )}
                  {agent.commissionModel === CommissionModel.ExternalSalesDK && (
                    <img
                      alt="External Commission Enabled Icon"
                      title="Commission Model Equal to External"
                      src="/assets/external-commission-enabled.svg"
                    ></img>
                  )}
                </div>

                <ActiveAgentMenu agent={agent} areBrokerFunctionsAvailable={areBrokerFunctionsAvailable} />
              </div>
            );
          })}
        </>
      )}

      <CreateAgentButton team={team} />
    </div>
  );
};

export default ActiveAgents;
